export const dashboard = {
  noAnnouncements: 'Geen nieuwe aankondigingen',
};
